module.exports = __webpack_public_path__ + "static/media/theMofG25.7f4510ae.png";